import React, { useState, useEffect } from 'react'
import './Fpv.css'
import { Button } from 'react-bootstrap'

function FpvModeButton({drone, click}) {
    return(
        <>
            {drone == null ? <></> : 
                <div className='navigation-elem'>
                    <Button style={{width: 'inherit'}} onClick={click}>FPV Режим</Button>
                </div>
            }
        </>
    )
}

export default FpvModeButton;